/**
 * The Temperatures screen's URL (`StorageTemperaturesPage`, which reads `?tab=`).
 *
 * A single function rather than a constant so every "Manage temperatures"
 * link in storage UI builds the same URL and lands on the same tab the
 * controller named, instead of each call site hand-writing the query string.
 */
export function storageTemperaturesHref(tab?: 'temperatures' | 'options' | 'mapping'): string {
  return tab ? `/inventory/storage-temperatures?tab=${tab}` : '/inventory/storage-temperatures'
}
